import {Component, Input, OnInit, Output, EventEmitter, LOCALE_ID, OnChanges, SimpleChanges} from '@angular/core';
import {UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {
  TypesService,
  SalesService,
  ApplicationService,
  NotificationService,
  ApplicationMappingService,
  HttpErrorHandlerService,
} from '../../../services';
import * as _ from 'lodash';
import {environment} from '../../../../environments/environment';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatInputModule} from '@angular/material/input';
import {ValidationPartialComponent} from '../partials';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatRadioModule} from '@angular/material/radio';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {NgIf, NgFor, DatePipe} from '@angular/common';
import {DataHandlerService} from '../../../services/data-handler.service';
import {FurtherAdvanceDialogComponent} from '../further-advance-dialog/further-advance-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {VxCoreService} from '../../../services/vx-core.service';
import {firstValueFrom} from 'rxjs';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-application-type',
  templateUrl: 'application-type.component.html',
  providers: [
    {provide: LOCALE_ID, useValue: 'en-AU'},
  ],
  standalone: true,
  imports: [NgIf, MatButtonModule, MatButtonModule, MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule,
    MatRadioModule, NgFor, MatFormFieldModule, MatFormFieldModule, ValidationPartialComponent, MatInputModule, MatProgressBarModule,
    MatExpansionModule, DatePipe, MatProgressSpinner]
})

export class ApplicationTypeComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public baseFormGroup: UntypedFormGroup;
  @Input() public formGroup: UntypedFormGroup;
  @Input() public brokerDetails: any;
  @Input() public baseModel: any;
  @Input() public originatorBrokers: UntypedFormGroup;
  @Input() public wizType: any;
  @Input() public isFurtherAdvance = false;
  @Input() public isInternalUser = false;
  @Output() public applicationTypeChange = new EventEmitter<any>();
  @Output() public savedApplicationsDisplayed = new EventEmitter<any>();
  @Output() public furtherAdvanceLoaded = new EventEmitter<any>();

  public applicationTypes = [];
  public partialApplications = [];
  public loadingResults = false;
  public displaySavedApplications = false;
  public importingFromJustice = false;
  private showLiErrorMsg = false;
  public showOpErrorMsg = false;
  public partialAppListLoading = false;

  private applicationTypesSlug = 'home-loan-application-types';
  private furtherAdvanceTypesSlug = 'further-advance-application-types';
  public furtherAdvanceTypes = [];

  constructor(public dataHandlerService: DataHandlerService,
              private typesService: TypesService,
              private salesService: SalesService,
              public notificationService: NotificationService,
              private applicationMappingService: ApplicationMappingService,
              private applicationService: ApplicationService,
              public dialog: MatDialog,
              public httpErrorHandlerService: HttpErrorHandlerService,
              public vxCoreService: VxCoreService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.populateApplicationTypes();
    this.populateFurtherAdvanceTypes();
    this.originatorBrokers.get('broker').valueChanges.subscribe(val => {
      if (val && val.id) {
        this.populatePartialApplications(val.id);
      }
    });

    console.log('isInternalUser', this.isInternalUser);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isFurtherAdvance && changes.isFurtherAdvance.currentValue) {
      this.formGroup.disable();
      this.displaySavedApplications = false;
    }
  }

  populateApplicationTypes() {
    this.typesService.getTypesList(this.applicationTypesSlug)
      .then((results: any[]) => {
        const activeEnvironmentSource = environment.auth?.active?.source;
        // this.applicationTypes = results.filter(t => t.ext.active[activeEnvironmentSource] && !t.ext.disabled);
        this.applicationTypes = results.filter(t => !t.ext.disabled);
        this.applicationTypes.sort(function (a, b) {
          return a.ext.sortOrder - b.ext.sortOrder;
        });

        console.log('applicationTypes', this.applicationTypes);
        console.log('activeEnvironmentSource', activeEnvironmentSource);

        this.updateSelectedAppType(this.formGroup.value.applicationType);
      });
  }

  populateFurtherAdvanceTypes() {
    this.typesService.getTypesList(this.furtherAdvanceTypesSlug)
      .then((results) => {
        this.furtherAdvanceTypes = results;
      });
  }

  populatePartialApplications(brokerId) {
    this.partialAppListLoading = true;
    this.partialApplications = [];
    const dateToday = new Date().getTime();
    this.salesService.listPartials(brokerId)
      .subscribe((results) => {
        this.partialAppListLoading = false;
        results.filter((res) => {
          let data: any;
          if (new Date(res.expiration).getTime() >= dateToday && res['appType'] === this.wizType) {
            data = JSON.parse(JSON.stringify(res['appData']));
            this.partialApplications.push({
              id: res._id,
              borrowers: data['app-personal-details'] ? this.getBorrowers(data['app-personal-details']['personList']) : '',
              applicationType: data['app-application-type'],
              created: res.created.when
            });
          }
        });
      });
  }

  getBorrowers(personList) {
    let borrowers = '';
    if (personList) {
      personList.forEach((p, i) => {
        if (i < personList.length - 1) {
          borrowers += p.firstName + ' ' + p.lastName + ',';
        } else {
          borrowers += p.firstName + ' ' + p.lastName;
        }
      });
    }
    return borrowers;
  }

  updateSelectedAppType(data) {
    const appType = this.applicationTypes.find(t => t.id === data);
    if (appType && appType.ext) {
      this.formGroup.get('vxApplicationType').patchValue(appType.ext.applicationType);
    }
    switch (data) {
      case 'new-bridging':
        this.displaySavedApplications = false;
        this.savedApplicationsDisplayed.emit(this.displaySavedApplications);
        this.applicationTypeChange.emit(data);
        this.formGroup.get('appId').disable();
        this.formGroup.get('appId').removeValidators(Validators.required);
        this.formGroup.get('accountNumber').disable();
        break;

      case 'new-personal':
        this.displaySavedApplications = false;
        this.savedApplicationsDisplayed.emit(this.displaySavedApplications);
        this.applicationTypeChange.emit(data);
        this.formGroup.get('appId').disable();
        this.formGroup.get('appId').removeValidators(Validators.required);
        this.formGroup.get('accountNumber').disable();
        this.formGroup.get('furtherAdvanceApplicationType').patchValue(null);
        this.formGroup.get('furtherAdvanceApplicationType').clearValidators();
        this.formGroup.get('furtherAdvanceApplicationType').updateValueAndValidity();
        break;

      case 'new-company':
      case 'new-trust':
        this.displaySavedApplications = false;
        this.savedApplicationsDisplayed.emit(this.displaySavedApplications);
        this.applicationTypeChange.emit(data);
        this.formGroup.get('appId').disable();
        this.formGroup.get('appId').removeValidators(Validators.required);
        this.formGroup.get('accountNumber').disable();
        this.formGroup.get('furtherAdvanceApplicationType').patchValue(null);
        this.formGroup.get('furtherAdvanceApplicationType').clearValidators();
        this.formGroup.get('furtherAdvanceApplicationType').updateValueAndValidity();
        break;

      case 'old-personal':
        this.formGroup.get('vxApplicationType').patchValue(appType.ext.applicationType);
        this.displaySavedApplications = false;
        this.savedApplicationsDisplayed.emit(this.displaySavedApplications);
        this.applicationTypeChange.emit(data);

        if (!this.isFurtherAdvance) {
          this.formGroup.get('appId').enable();
          this.formGroup.get('appId').addValidators(Validators.required);
        }

        this.formGroup.get('accountNumber').disable();
        this.formGroup.get('furtherAdvanceApplicationType').addValidators(Validators.required);
        this.formGroup.get('furtherAdvanceApplicationType').updateValueAndValidity();
        break;

      case 'limit-increase':
        this.displaySavedApplications = false;
        this.savedApplicationsDisplayed.emit(this.displaySavedApplications);
        this.applicationTypeChange.emit(null);
        this.formGroup.get('appId').disable();
        this.formGroup.get('appId').removeValidators(Validators.required);
        this.formGroup.get('accountNumber').enable();
        this.formGroup.get('furtherAdvanceApplicationType').patchValue(null);
        this.formGroup.get('furtherAdvanceApplicationType').clearValidators();
        this.formGroup.get('furtherAdvanceApplicationType').updateValueAndValidity();
        break;

      case 'continue':
        console.log('display saved applications');
        this.formGroup.get('applicationType').patchValue(null);
        this.displaySavedApplications = true;
        this.savedApplicationsDisplayed.emit(this.displaySavedApplications);
        this.formGroup.get('appId').disable();
        this.formGroup.get('appId').removeValidators(Validators.required);
        this.formGroup.get('accountNumber').disable();
        this.formGroup.get('furtherAdvanceApplicationType').patchValue(null);
        this.formGroup.get('furtherAdvanceApplicationType').clearValidators();
        this.formGroup.get('furtherAdvanceApplicationType').updateValueAndValidity();
        break;

      default:
        this.displaySavedApplications = false;
        this.formGroup.get('appId').disable();
        this.formGroup.get('appId').removeValidators(Validators.required);
        this.formGroup.get('accountNumber').disable();
        this.formGroup.get('furtherAdvanceApplicationType').patchValue(null);
        this.formGroup.get('furtherAdvanceApplicationType').clearValidators();
        this.formGroup.get('furtherAdvanceApplicationType').updateValueAndValidity();
    }
  }

  updateFurtherAdvanceType(value) {
    console.log('updateFurtherAdvanceType', value);
  }

  loadPartial(id, app: any, furtherAdvanceApplicationType?, faParentAppId?) {
    if (!furtherAdvanceApplicationType && app && app.applicationType && app.applicationType.furtherAdvanceApplicationType) {
      furtherAdvanceApplicationType = app.applicationType.furtherAdvanceApplicationType;

      if (!faParentAppId && app.applicationType.appId) {
        faParentAppId = app.applicationType.appId;
      }
    }

    sessionStorage.removeItem('partial-data');
    const wiz = _.replace(this.wizType, 'wiz-', '');
    const wizUrl = (furtherAdvanceApplicationType) ? `/application/${wiz}?id=${id}&step=1&faType=${furtherAdvanceApplicationType}&faParentAppId=${faParentAppId}` : `/application/${wiz}?id=${id}&step=1`;
    window.open(wizUrl, '_self');
  }

  deletePartial(id, index) {
    this.salesService.deletePartial(id)
      .subscribe((res) => {
        console.log('[deletePartial]', id, res);
        this.partialApplications.splice(index, 1);
      });
  }

  importAppErrorHandler(err, furtherAdvanceApplicationType, appId) {
    const errorSlug = [401, 403].includes(err.status)  ? 'out-of-permission' : (this.getErrorSlug(err?.error?.message) || '');
    if (errorSlug === 'proceed-with-no-error') {
      this.launchFaDialog(furtherAdvanceApplicationType, appId);
    } else {
      const errorMsg = this.httpErrorHandlerService.getErrorMessage(errorSlug) || 'Could not load application data for Application: ' + appId + '.';
      this.notificationService.toast('error', errorMsg, 'Error');
    }
  }

  /**
   * Imports an application and converts the internal submission shape to the Application Wizard Form Group shape
   * @param appType
   * @param justiceApplication
   */
  async importApplication(appType, justiceApplication = false) {
    console.log('loadApplication', appType);
    this.importingFromJustice = false;
    const appId = this.formGroup.get('appId').value;
    const furtherAdvanceApplicationType = this.formGroup.get('furtherAdvanceApplicationType').value;

    if (appId.toString().startsWith('8')) {
      if (furtherAdvanceApplicationType === 'new-security') {
        this.launchFaDialog(furtherAdvanceApplicationType, appId);
      } else {
        this.vxCoreService.checkVxApplicationEligibility(appId)
        .subscribe({
          next: (response) => {
            if (furtherAdvanceApplicationType && appId) {
              this.launchFaDialog(furtherAdvanceApplicationType, appId, justiceApplication);
            } else {
              this.notificationService.toast('error', 'Please ensure you have selected existing borrower application type and entered an application ID', 'Error');
            }
          },
          error: (err) => {
            console.error('There was an error!', err);
            this.importAppErrorHandler(err, furtherAdvanceApplicationType, appId);
          }
        });
      }
    } else {
      this.importingFromJustice = true;

      try {
        const checkImported: any = await this.vxCoreService.checkTontoImported(appId);
        if (checkImported && checkImported.applicationId) {
          this.formGroup.get('appId').patchValue(checkImported.applicationId);
          this.importApplication(appType, checkImported?.flags?.imported && checkImported.tontoId === +(appId));
          return;
        }
      } catch (error) {
        if (error.status === 404) {
          console.error('Tonto not found:', error);
          this.importingFromJustice = true;

          // Proceed to validateShapeA if 404 is returned
          this.applicationService.validateShapeA(appId)
            .subscribe({
              next: async (validationResponse: any) => {
                console.log('validateShapeA', validationResponse);

                this.applicationService.importShapeA(appId)
                  .subscribe({
                    next: (response: any) => {
                      if (response.status === 'error') {
                        this.importingFromJustice = false;
                        console.log('importShapeA - error', response);
                        this.notificationService.toast('error', 'Could not import application data for Application: ' + appId + '.', 'Error');
                      } else if (response.status === 'completed' && response && response.applicationIds.length) {
                        console.log('importShapeA', response);

                        setTimeout(() => {
                          this.launchFaDialog(furtherAdvanceApplicationType, response.applicationIds[0], true);
                          this.importingFromJustice = false;
                        }, 1000);
                      } else {
                        this.importingFromJustice = false;
                        this.notificationService.toast('error', 'Could not import application data for Application: ' + appId + '.', 'Error');
                      }
                    },
                    error: (error: any) => {
                      this.importingFromJustice = false;
                      console.error('There was an error when importing the application', error);
                      this.importAppErrorHandler(error, furtherAdvanceApplicationType, appId);
                    }
                  });
              },
              error: (err) => {
                this.importingFromJustice = false;
                console.error('There was an error when validating the application', err);
                this.importAppErrorHandler(error, furtherAdvanceApplicationType, appId);
              }
            });
        } else {
          console.error('An error occurred:', error);
          this.notificationService.toast('error', 'Could not import application data for Application: ' + appId + '.', 'Error');
        }

        return;
      }
    }
  }

  getErrorSlug(failedRules) {
    const furtherAdvanceApplicationType = this.formGroup.get('furtherAdvanceApplicationType')?.value;
    const failedRulesArray = failedRules.split(',');

    if (_.includes(failedRulesArray, 'application-is-not-smsf') || _.includes(failedRulesArray, 'has-smsf')) {
      return 'app-is-smsf';
    }

    if (_.includes(failedRulesArray, 'application-is-not-discharged')) {
      if (furtherAdvanceApplicationType === 'existing-security') {
        return 'app-is-discharged-existing-security';
      } else if (furtherAdvanceApplicationType === 'existing-security-new-security') {
        return 'app-is-discharged-existing-security-new-security';
      }
    }

    if (_.includes(failedRulesArray, 'application-is-home-loan-product-category')) {
      if (furtherAdvanceApplicationType === 'existing-security') {
        return 'app-is-car-existing-security';
      } else if (furtherAdvanceApplicationType === 'existing-security-new-security') {
        return 'app-is-car-existing-security-new-security';
      }
    }

    if (_.includes(failedRulesArray, 'application-is-construction-with-banking-account-status-or-not-construction')) {
      if (furtherAdvanceApplicationType === 'existing-security') {
        return 'app-is-home-construction-retained-more-than-zero-existing-security';
      } else if (furtherAdvanceApplicationType === 'existing-security-new-security') {
        return 'app-is-home-construction-retained-more-than-zero-existing-security-new-security';
      }
    }

    if (_.includes(failedRulesArray, 'application-type-is-new') || _.includes(failedRulesArray, 'not-include:application-type further-advance')) {
      if (furtherAdvanceApplicationType === 'existing-security') {
        return 'app-is-fa-fa-by-variation-additional-advance-existing-security';
      } else if (furtherAdvanceApplicationType === 'existing-security-new-security' || furtherAdvanceApplicationType === 'new-security') {
        return 'proceed-with-no-error';
      }
    }

    return null;
  }

  /**
   * launchFaDialog
   * @param furtherAdvanceApplicationType
   * @param appId
   * @param justiceApplication
   */
  launchFaDialog(furtherAdvanceApplicationType: any, appId: any, justiceApplication = false) {
    const confirmDialogRef = this.dialog.open(FurtherAdvanceDialogComponent, {
      width: '30%',
      disableClose: true,
      data: {
        title: 'Loading application data',
        furtherAdvanceApplicationType,
        appId,
        justiceApplication,
        baseModel: this.baseModel
      }
    });

    confirmDialogRef.afterClosed().subscribe((result: any) => {
      if (result.success) {
        this.furtherAdvanceLoaded.emit({model: result.data, faType: furtherAdvanceApplicationType, appId: appId});
      } else {
        const err = {
          status: result?.data?.status,
          error: {
            message: result?.data?.error?.message || result?.data,
          },
        };
        this.importAppErrorHandler(err, furtherAdvanceApplicationType, appId);
      }
    });
  }

  loadApplication(appType, furtherAdvanceApplicationType?, faParentAppId?) {
    console.log('loadApplication', appType, furtherAdvanceApplicationType, faParentAppId);
    let id: any;
    this.showLiErrorMsg = false;
    this.showOpErrorMsg = false;
    if (appType === 'old-personal') {
      id = this.formGroup.get('appId').value;
    } else if (appType === 'limit-increase') {
      id = this.formGroup.get('accountNumber').value;
    }
    this.loadingResults = true;
    this.applicationService.retrieveApplication(id, appType)
      .subscribe(
        (result) => {
          this.loadingResults = false;
          console.log(result);
          if (!_.isEmpty(result)) {
            console.log('[Result Loaded]', id);
            const modifiedPacket = this.modifyPacket(result, appType);
            const body = {
              appData: modifiedPacket,
              appType: 'wiz-home-loan',
            };

            console.log('[Create Partial]', body);

            this.salesService.createPartial(body)
              .subscribe(
                (partialId) => {
                  if (partialId.length > 0) {
                    this.loadPartial(partialId, null, furtherAdvanceApplicationType, faParentAppId);
                  }
                }
              );
          } else {
            if (appType === 'old-personal') {
              this.showOpErrorMsg = true;
            } else if (appType === 'limit-increase') {
              this.showLiErrorMsg = true;
            }
          }
        }
      );
  }

  modifyPacket(packet, appType) {
    const modifiedPacket = _.clone(packet);

    console.log('modifiedPacket', modifiedPacket);

    if (appType === 'old-personal') {
      delete modifiedPacket['app-home-loan-details'];

      if (modifiedPacket['app-personal-details'] && modifiedPacket['app-personal-details']['personList']) {
        modifiedPacket['app-personal-details']['personList'].forEach((person: any) => {
          person.stayAtHomeMonths = null;
          person.stayAtHomeYears = null;
        });
      }

      if (modifiedPacket['app-employment-details'] && modifiedPacket['app-employment-details']['employmentList']) {
        modifiedPacket['app-employment-details']['employmentList'].forEach((employment: any) => {
          employment.currentEmployments.forEach((currentEmployment: any) => {
            currentEmployment.lengthMonths = null;
            currentEmployment.lengthYears = null;

            currentEmployment.incomes.forEach((income: any) => {
              income.amount = null;
            });
          });
        });
      }
    } else if (appType === 'limit-increase') {
      const {splits} = modifiedPacket['app-home-loan-details'];
      modifiedPacket['app-home-loan-details'] = {
        'purposesSubTotal': 0,
        'feesFundedTotal': '0.00',
        'feesOtherTotal': '0.00',
        'depositsTotal': 0,
        'loanFacilityTotal': '0.00',
        'sacrifice': null,
        'purposes': [],
        'deposits': [],
        'fees': {},
        splits
      };

    }
    modifiedPacket['app-originator-broker'] = this.originatorBrokers.value;
    return modifiedPacket;
  }
}
